import { SVGPureIcon } from '@/ui';
import inputTypeStore from '@/components/input-file/input-type';
import globalStore from '@/store/global';
import { Tooltip, Dropdown } from 'antd';
import { observer } from 'mobx-react-lite';
import userStore from '@/store/user';
import knowledgeChoiceStore from '../knowledge-choice/store';
import navbarStore from '@/store/navbar';
import modelChoiceStore from '../model-choice/store';
import appLogger from '@public/log/monitor';
import UploadFile from './UploadFile';
import UploadImg from './UploadImg';
import { useState } from 'react';
import UploadAll from './UploadAll';
import KnowledgeChoiceModal from '../modal/knowledge-choice';
import { request } from '@/common';
import Loader from '@/common/helper/loader';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { McpAgentType } from '@shared/constants/mcp';
import MultiKnowledge from '../kb-node-tree/MultiKnowledge';
import { isEnableEnterpriseKbPage } from '@/components/kb-node-tree/utils'
import { default as PersonalMultiKnowledge } from '@/components/chat/MultiKnowledge';
import { default as personalMultiKnowledgeStore } from './MultiKnowledge/store';

const dropList = (scene, supportKnowledge, handleCheckKnowledge, setShowDropdown) => {
  return (
    <div
      className="w-[150px] px-[8px] py-[8px] rounded-[16px] bg-white flex flex-col"
      style={{
        boxShadow: '0px 2px 8px 0px #0000001A',
        border: '1px solid rgba(0,0,0,0.1)',
      }}
    >
      {supportKnowledge ? (
        <>
          <UploadAll>
            <div
              onClick={() => {
                appLogger.log({
                  key: `aibot_${scene}`,
                  action: 'click',
                  arrt: 'upload_btn',
                  ext: modelChoiceStore.curId
                    ? navbarStore.chatModels[modelChoiceStore.curId].title
                    : '', // 发送时选择的助手名
                  role_id: modelChoiceStore.curId,
                  ext1: 'file',
                });
                if (!userStore.isUser) {
                  userStore.gotoLogin();
                }
              }}
              className={[
                'cursor-pointer',
                'h-40px px-8px flex items-center hover:bg-[rgba(0,0,0,0.06)] rounded-8px',
              ]}
            >
              <SVGPureIcon name="file_upload_file" className="size-20px mr-8px" />
              上传本地文件
            </div>
          </UploadAll>

          <div
            onClick={evt => {
              appLogger.log({
                key: `aibot_${scene}`,
                action: 'click',
                arrt: 'upload_btn',
                ext: modelChoiceStore.curId
                  ? navbarStore.chatModels[modelChoiceStore.curId].title
                  : '', // 发送时选择的助手名
                role_id: modelChoiceStore.curId,
                ext1: 'file',
              });
              userStore.doWhenLogin(() => {
                // 弹窗
                KnowledgeChoiceModal.show({
                  onSucc: list => {
                    if (list?.length) {
                      handleCheckKnowledge(list[0]);
                    }
                  },
                });
                setShowDropdown(false);
              });
            }}
            className={[
              'cursor-pointer',
              'h-40px px-8px flex items-center hover:bg-[rgba(0,0,0,0.06)] rounded-8px',
            ]}
          >
            <SVGPureIcon name="knowledge" className="size-20px mr-8px" />
            选择知识库
          </div>
        </>
      ) : (
        <>
          <UploadImg>
            <div
              onClick={evt => {
                appLogger.log({
                  key: `aibot_${scene}`,
                  action: 'click',
                  arrt: 'upload_btn',
                  ext: modelChoiceStore.curId
                    ? navbarStore.chatModels[modelChoiceStore.curId].title
                    : '', // 发送时选择的助手名
                  role_id: modelChoiceStore.curId,
                  ext1: 'image',
                });
                if (!userStore.isUser) {
                  userStore.gotoLogin();
                }
              }}
              className={[
                'cursor-pointer',
                'h-40px px-8px flex items-center hover:bg-[rgba(0,0,0,0.06)] rounded-8px',
              ]}
            >
              <SVGPureIcon name="file_upload_img" className="size-20px mr-8px" />
              上传图片
            </div>
          </UploadImg>
          <UploadFile>
            <div
              onClick={evt => {
                appLogger.log({
                  key: `aibot_${scene}`,
                  action: 'click',
                  arrt: 'upload_btn',
                  ext: modelChoiceStore.curId
                    ? navbarStore.chatModels[modelChoiceStore.curId].title
                    : '', // 发送时选择的助手名
                  role_id: modelChoiceStore.curId,
                  ext1: 'file',
                });
                if (!userStore.isUser) {
                  userStore.gotoLogin();
                }
              }}
              className={[
                'cursor-pointer',
                'h-40px px-8px flex items-center hover:bg-[rgba(0,0,0,0.06)] rounded-8px',
              ]}
            >
              <SVGPureIcon name="file_upload_file" className="size-20px mr-8px" />
              上传文件
            </div>
          </UploadFile>
        </>
      )}
    </div>
  );
};

function UploadButton(props) {
  const {
    className,
    simple,
    disabled,
    isShowSo,
    scene = 'home',
    supportKnowledge, // true: 文件可选择图片，支持选择知识库
    multiFile,
    multiImage,
    singleImage,
    onlyKnowledge,
    notMedias,
    agentInfo,
    recommendAgent,
    recommendAgentOptions,
  } = props;
  const [showDropdown, setShowDropdown] = useState(false);
  const currentLocation = useLocation();
  const isUseNetwork = globalStore.is_so && isShowSo;
  const isUseKnowledge = knowledgeChoiceStore.curId && false; // 旧版本知识库单选已废弃
  const disabledFile = disabled || isUseNetwork || (isUseKnowledge && !supportKnowledge);
  const disabledToolTip = useMemo(() => {
    if (isUseNetwork) {
      return `联网搜索不支持`;
    }
    if (isUseKnowledge) {
      if (globalStore.globalConfig.supportModelWithMultiKnowledge) {
        return '';
      }
      if (!(supportKnowledge && currentLocation.pathname != '/chathome')) {
        return `选择知识库后不支持`;
      }
      if (supportKnowledge && [McpAgentType.noserver].includes(agentInfo?.agent_type)) {
        return `选择知识库后不支持`;
      }
    }
    return '';
  }, [isUseNetwork, isUseKnowledge, supportKnowledge, currentLocation]);

  const handleCheckKnowledge = item => {
    if (!item?.folder_id) {
      return;
    }

    const { folder_id, ks_id = '' } = item;
    return request
      .post(
        '/knw_cloud/inRouter/v1/knowledge/file/list',
        {
          folder_id,
          ks_id,
          page: 1,
          size: 1, // 最大 50
          type: 0,
          count_success: 1, //统计时是否过滤解析失败的，只要成功的。默认0
          need_total_size: true,
        },
        { dataIsJson: true }
      )
      .then(res => {
        const { data } = res;
        const { total, total_size } = data;

        const dataset_info = {
          [folder_id]: {
            name: item.name,
            total,
            total_size,
          },
        };
        inputTypeStore.updateTempData('tempFile', [{ dataset_info }]);
      })
      .catch(res => {
        Loader.error(res);
      });
  };

  if ((!globalStore.globalConfig.supportKnowledgeWithAgent || multiFile) && supportKnowledge) {
    return (
      <UploadAll disable={disabled || disabledToolTip} notMedias={notMedias}>
        <Tooltip title={`${disabledToolTip}上传文件`}>
          <button
            className={[
              'flex items-center',
              'rounded-full cursor-pointer text-primary',
              { 'upload-btn-disable': disabled },
              { 'bg-[rgba(0,0,0,0.06)]': showDropdown },
              simple
                ? `!border-none bg-transparent p-6px hover:bg-[rgba(0,0,0,0.06)]`
                : 'px-12px py-7px',
              className,
            ]}
            disabled={disabled}
            onClick={() => {
              if (!userStore.isUser) {
                userStore.gotoLogin();
              }
            }}
            id="Tag_UploadButton" // 如果你坚持要修改这个 id 请联系daijinru
          >
            <SVGPureIcon name="file" className="size-20px" />
            {simple ? null : <span className="text-13px leading-18px ml-4px">上传文件</span>}
          </button>
        </Tooltip>
      </UploadAll>
    );
  }
  if (multiImage && supportKnowledge) {
    return (
      <UploadAll onlyImages disable={disabled || disabledToolTip}>
        <Tooltip title={`${disabledToolTip}上传图片`}>
          <button
            className={[
              'flex items-center',
              'rounded-full cursor-pointer text-primary',
              { 'upload-btn-disable': disabled },
              { 'bg-[rgba(0,0,0,0.06)]': showDropdown },
              simple
                ? `!border-none bg-transparent p-6px hover:bg-[rgba(0,0,0,0.06)]`
                : 'px-12px py-7px',
              className,
            ]}
            disabled={disabled}
            onClick={() => {
              if (!userStore.isUser) {
                userStore.gotoLogin();
              }
            }}
          >
            <SVGPureIcon name="chat_share_img" className="size-20px" />
            {simple ? null : <span className="text-13px leading-18px ml-4px">上传图片</span>}
          </button>
        </Tooltip>
      </UploadAll>
    );
  }
  if (singleImage && supportKnowledge) {
    return (
      <UploadImg disable={disabled || disabledToolTip}>
        <Tooltip title={`${disabledToolTip}上传图片`}>
          <button
            className={[
              'flex items-center',
              'rounded-full cursor-pointer text-primary',
              { 'upload-btn-disable': disabled },
              { 'bg-[rgba(0,0,0,0.06)]': showDropdown },
              simple
                ? `!border-none bg-transparent p-6px hover:bg-[rgba(0,0,0,0.06)]`
                : 'px-12px py-7px',
              className,
            ]}
            disabled={disabled}
            onClick={() => {
              if (!userStore.isUser) {
                userStore.gotoLogin();
              }
            }}
          >
            <SVGPureIcon name="chat_share_img" className="size-20px" />
            {simple ? null : <span className="text-13px leading-18px ml-4px">上传图片</span>}
          </button>
        </Tooltip>
      </UploadImg>
    );
  }
  if (onlyKnowledge && supportKnowledge) {
    if (!globalStore.globalConfig.supportMultiKnowledge) {
      return null;
    }
    if (isEnableEnterpriseKbPage()) {
      return (
        <MultiKnowledge
          title={
            inputTypeStore.tempFile?.length
              ? '上传图片/文件后，不支持选择知识库'
              : `${disabledToolTip}选择知识库`
          }
          disabled={disabled}
          disabledToolTip={disabledToolTip}
          userInfo={userStore.bizLoginInfo.userInfo}
        />
      );
    }
    // 智能体对话，使用个人知识库
    return (
      <PersonalMultiKnowledge
        disabled={disabledToolTip || !userStore.isUser || inputTypeStore.tempFile?.length}
        onOpenChange={setShowDropdown}
      >
        <Tooltip
          title={
            inputTypeStore.tempFile?.length
              ? '上传图片/文件后，不支持选择知识库'
              : `${disabledToolTip}选择知识库`
          }
          open={showDropdown ? false : undefined}
        >
          <button
            className={[
              'flex items-center',
              'rounded-full cursor-pointer text-primary',
              {
                'bg-[rgba(0,0,0,0.06)] !hover:bg-[rgba(0,0,0,0.09)]':
                  !disabledToolTip &&
                  personalMultiKnowledgeStore.selectAllStatus != 'none' &&
                  !inputTypeStore.tempFile?.length,
              },
              { 'opacity-30': disabledToolTip || !!inputTypeStore.tempFile?.length },
              simple ? `!border-none p-6px hover:bg-[rgba(0,0,0,0.06)]` : 'px-12px py-7px',
              className,
            ]}
            disabled={disabled}
            onClick={() => {
              if (!userStore.isUser) {
                userStore.gotoLogin();
              }
            }}
          >
            <SVGPureIcon name="knowledge" className="size-20px" />
          </button>
        </Tooltip>
      </PersonalMultiKnowledge>
    );
  }

  // 首页推荐智能体专用
  if (recommendAgent) {
    return (
      <div className="flex items-center">
        {recommendAgentOptions.enableUploadImg ? (
          <UploadImg>
            <button
              className={[
                'flex items-center',
                'rounded-8px cursor-pointer text-primary',
                'bg-white hover:bg-[rgba(0,0,0,0.03)] border-1px border-black border-opacity-16',
                'px-12px py-7px mr-8px',
              ]}
              onClick={() => {
                if (!userStore.isUser) {
                  userStore.gotoLogin();
                }
              }}
            >
              <SVGPureIcon name="chat_share_img" className="size-20px" />
              {simple ? null : <span className="text-13px leading-18px ml-4px">上传图片</span>}
            </button>
          </UploadImg>
        ) : null}

        {recommendAgentOptions.enableUploadFile ? (
          <UploadFile>
            <div
              onClick={evt => {
                appLogger.log({
                  key: `aibot_${scene}`,
                  action: 'click',
                  arrt: 'upload_btn',
                  ext: modelChoiceStore.curId
                    ? navbarStore.chatModels[modelChoiceStore.curId].title
                    : '', // 发送时选择的助手名
                  role_id: modelChoiceStore.curId,
                  ext1: 'file',
                });
                if (!userStore.isUser) {
                  userStore.gotoLogin();
                }
              }}
              className={[
                'flex items-center',
                'rounded-8px cursor-pointer text-primary',
                'bg-white hover:bg-[rgba(0,0,0,0.03)] border-1px border-black border-opacity-16',
                'px-12px py-7px mr-8px',
              ]}
            >
              <SVGPureIcon name="file" className="size-20px mr-8px" />
              上传文件
            </div>
          </UploadFile>
        ) : null}
      </div>
    );
  }
  return (
    <Dropdown
      dropdownRender={() =>
        dropList(scene, supportKnowledge, handleCheckKnowledge, setShowDropdown)
      }
      trigger="hover"
      placement="topLeft"
      open={showDropdown}
      disabled={disabledFile}
      onOpenChange={visible => {
        setShowDropdown(visible);
      }}
    >
      <Tooltip title={disabledToolTip ? `${disabledToolTip}上传文件` : ''}>
        <button
          className={[
            'flex items-center',
            'rounded-full cursor-pointer text-primary',
            { 'upload-btn-disable': disabled },
            { 'bg-[rgba(0,0,0,0.06)]': showDropdown },
            simple
              ? `!border-none bg-transparent p-6px hover:bg-[rgba(0,0,0,0.06)]`
              : 'px-12px py-7px',
            className,
          ]}
          disabled={disabled}
          id="Tag_UploadButton" // 如果你坚持要修改这个 id 请联系daijinru
        >
          <SVGPureIcon name="file" className="size-20px" />
          {simple ? null : <span className="text-13px leading-18px ml-4px">上传文件</span>}
        </button>
      </Tooltip>
    </Dropdown>
  );
}

export default observer(UploadButton);
